module.exports = __webpack_public_path__ + "media/images/video/purebarre-app-promo-95887bc2898327674739a8a7a50aaab2.png";